import { User, BusinessRole } from '../types/UsersFilterData';

export function extractBusinessRolesFromUsers(users: User[]): BusinessRole[] {
    const businessRolesMap = new Map<string | number, BusinessRole>();
    
    users.forEach((user) => {
        if (user.roles) {
            user.roles.forEach((role) => {
                if (!businessRolesMap.has(role.id)) {
                    businessRolesMap.set(role.id, {
                        id: role.id,
                        name: role.name
                    });
                }
            });
        }
    });
    
    return Array.from(businessRolesMap.values()).sort((a, b) => a.name.localeCompare(b.name));
}